import {useRef,useMemo} from 'react';
import COMPONENT_MAP from '../Repository/Components.js';

// Supplies the generic ImageTab (coda_frontend/src/core/components/Repository/ImageTab.js)
// with the parent_id/table_name pair it needs to read and attach the fault's
// annotated frame through the framework's generic Attachment model - see
// database/models/attachment.py.
//
// useMemo + a stable executeQuery ref (matching AnalysisReportFaultDrills.js's
// ListTab wrapper) are required here, not optional: ImageTab's own fetch
// effect depends on entityParams' identity (via its getRecords useCallback).
// Without memoizing, this component builds a brand-new entityParams array on
// every render - including renders triggered by anything unrelated further up
// the tree (session-expiry countdown, notification polling, etc.) - which
// re-triggers ImageTab's fetch every time, indefinitely. That's invisible
// when the tab has zero images to show, but shows up as a nonstop
// getObjectRecords/Attachment poll in the backend logs once there's real data.
const AnalysisReportVariableImage=({parentId,application,userData,parent,refreshToken})=>{
    const executeQuery=useRef(true);

    const renderImageTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ImageTab'];
        return Component?(
            <Component
                parentId={parentId}
                parentTable={'analysis_report_variable'}
                parent={parent}
                application={application}
                userData={userData}
                refreshToken={refreshToken}
                entityParams={['parent_id='+parentId,'table_name=analysis_report_variable','is_image=True']}
                file={'AnalysisReportVariableImage.js'}
                height={'40vh'}
                executeQuery={executeQuery}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId,refreshToken]);

    return renderImageTab;
}
export default AnalysisReportVariableImage;
